/** 各フェーズ定義 */
export const PHASE = {
  EXECUTE: "execute",
  DISPLAY_DTC: "displayDtc",
  DISPLAY_FFD: "displayFfd",
  FORMAT_ERROR: "format_error",
  ERROR: "error",
  MEMO: "memo",
  RE_GET: "reGet"
};

/** API定義 */
export const API_TYPE = {
  STANDBY: 'standby',
  READ: 'read',
  READ_FFD: 'read_ffd',
  TERMINATE: 'terminate',
  DISPOSE: 'dispose'
};

/** 現在セッション */
export const SESSION_PROPERTY = {
  DEFAULT: 0,
  NON_DEFAULT: 1
};
